/**
 * Drawer — выезжающая справа панель (История изменений строки). Оверлей + панель.
 * Доступность: role="dialog" aria-modal, фокус-трап, Esc/клик по оверлею закрывают.
 */

import { useRef, type ReactNode } from 'react';
import { cx } from './cx';
import { useDismiss } from './useDismiss';
import { useFocusTrap } from './useFocusTrap';
import { Button } from './Button';
import { IconX } from './icons';

export interface DrawerProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

export function Drawer({ title, onClose, children, className }: DrawerProps): JSX.Element {
  const panelRef = useRef<HTMLDivElement>(null);
  const titleId = useRef(`pw-drw-${Math.random().toString(36).slice(2, 9)}`).current;

  useDismiss({ enabled: true, onDismiss: onClose, refs: [panelRef] });
  useFocusTrap(panelRef, true);

  return (
    <div className="pw-overlay pw-overlay--right">
      <div
        ref={panelRef}
        className={cx('pw-drawer', className)}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <div className="pw-drawer__head">
          <h2 id={titleId} className="pw-drawer__title">
            {title}
          </h2>
          <Button
            variant="ghost"
            size="sm"
            className="pw-icon-btn"
            aria-label="Закрыть"
            onClick={onClose}
            icon={<IconX size={16} />}
          />
        </div>
        <div className="pw-drawer__body">{children}</div>
      </div>
    </div>
  );
}
